<template>
  <div class="wrapper-content">
    <div class="wrapper-left">
      <el-tree
        :data="departmentData"
        show-checkbox
        node-key="id"
        ref="tree"
        highlight-current
        :check-strictly="true"
        @check="checkChange"
        :props="defaultProps"
        :default-expanded-keys="[editCheckId]"
      >
      </el-tree>
    </div>
    <div class="wrapper-right">
      <transition name="fade">
        <div class="no-data" v-if="editCheckId === ''"><i class="icon-font">&#xe6be;</i>请选择公司或部门</div>
      </transition>
      <transition name="enter-fade">
        <div class="wrapper-right-content" v-if="editCheckId !== ''">
          <div class="wrapper-right-operation" style="padding-top: 0;padding-bottom: 1vw;border-bottom: dashed 0.1vw #3b79a1">
            <div class="wrapper-right-operation-list">
              <div class="four-font-wrapper margin-right" @click="showAddModal(1)"><div class="icon-font">&#xe605;</div>添加部门</div>
<!--              <div class="two-font-wrapper margin-right" @click="showAddModal(2)"><div class="icon-font">&#xec11;</div>修改</div>-->
              <div class="four-font-wrapper margin-right" @click="deleteAll"><div class="icon-font">&#xe646;</div>批量删除</div>
            </div>
            <div class="wrapper-right-operation-list">
              <div class="input-wrapper" style="margin-right: 1vw">
                <input placeholder="请输入关键字" v-model="search.value"/>
              </div>
              <div class="query button" @click="handleSearch(true)">查询</div>
            </div>
          </div>
          <div class="detail">
            <div class="detail-box">
              <div class="loading-data" v-if="loading">
                <i class="el-icon-loading"></i>
                <div>加载中，请稍后···</div>
              </div>
              <div class="detail-nav">
                <div class="detail-item" style="width: 10%">
                  <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
                </div>
                <div class="detail-item" style="width: 15%">ID</div>
                <div class="detail-item" style="width: 15%">部门简称</div>
                <div class="detail-item" style="width: 15%">部门全称</div>
                <div class="detail-item" style="width: 15%">排序</div>
                <div class="detail-item" style="width: 15%">备注</div>
                <div class="detail-item" style="width: 15%">操作</div>
              </div>
              <div class="detail-content" v-if="!loading">
                <div class="detail-list-wrapper" v-if="tableData.length>0" v-for="(data,index) in tableData" :key="index">
                  <div class="detail-item" style="width: 10%" >
                    <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data.id)"></div>
                  </div>
                  <div class="detail-item" style="width: 15%">{{data.id}}</div>
                  <div class="detail-item" style="width: 15%">{{data.simplename}}</div>
                  <div class="detail-item" style="width: 15%">{{data.fullname || '--'}}</div>
                  <div class="detail-item" style="width: 15%">{{data.num || '--'}}</div>
                  <div class="detail-item" style="width: 15%">{{data.tips || '--'}}</div>
                  <div class="detail-item" style="width: 15%">
                    <div class="detail-btn item-look" style="margin-right: 0.5vw" @click="showAddModal(3, data)">修改</div>
                    <div class="detail-btn item-delete" @click="deleteSingle(data.id)">删除</div>
                  </div>
                </div>
                <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
              </div>
              <div class="page-wrapper" v-if="!loading && total > rows">
                <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
                <div class="page-wrapper-right">
                  <div class="page-btn" @click="firstPage">首页</div>
                  <div class="page-btn" @click="previousPage">上一页</div>
                  <div class="page-btn" @click="nextPage">下一页</div>
                  <div class="page-btn" @click="lastPage">尾页</div>
                </div>
              </div>
            </div>
            <transition name="fade">
              <div class="alert-box" v-if="show">
                <div class="alert-content">
                  <div class="alert-content-title">删除提醒</div>
                  <div class="alert-content-msg">是否确认删除选中数据?</div>
                  <div class="alert-content-btn">
                    <div class="btn-cancel button" @click="cancelDelete">取消</div>
                    <div class="btn-confirm button" @click="confirmDelete">确认</div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <transition name="fade">
            <div class="alert-box" v-if="showAdd">
              <div class="alert-content" style="width: auto;padding: 1vw 2vw">
                <div class="alert-content-title">{{dType === 1 ? '添加部门' : '修改部门'}}</div>
                <div class="alert-content-msg" style="width: 100%;flex-direction: column">
                  <div class="alert-list">
                    <div class="input-contain" style="margin-right: 2vw">
                      <div class="input-title">部门名称：</div>
                      <div class="input-wrapper">
                        <input placeholder="" v-model="item.simplename"/>
                      </div>
                    </div>
                    <div class="input-contain">
                      <div class="input-title" style="padding-left: 1.78vw">排序：</div>
                      <div class="input-wrapper">
                        <input placeholder="" v-model="item.num"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="alert-content-msg" style="width: 100%;flex-direction: column">
                  <div class="alert-list">
                    <div class="input-contain" style="margin-right: 2vw">
                      <div class="input-title">部门全称：</div>
                      <div class="input-wrapper">
                        <input placeholder="" v-model="item.fullname"/>
                      </div>
                    </div>
                    <div class="input-contain">
                      <div class="input-title" style="padding-left: 1.78vw">备注：</div>
                      <div class="input-wrapper">
                        <input placeholder="" v-model="item.tips"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="alert-content-msg" style="width: 100%;flex-direction: column">
                  <div class="alert-list">
                    <div class="input-contain">
                      <div class="input-title">上级部门：</div>
                      <TreeSingle :content="title_" :editCheckId="editCheckId_" :items="departmentData_" v-on:sendInfo = "showDropInfo"></TreeSingle>
                    </div>
                  </div>
                </div>
                <div class="alert-content-btn">
                  <div class="btn-cancel button" @click="cancelAdd">取消</div>
                  <div class="btn-confirm button" @click="confirmAdd">确认</div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import DropDown from '../../components/DropDownSingle.vue'
import TreeSingle from '../../components/TreeSingle.vue'
import {deptTree, deptAdd, deptUpdate, delDept, deptList, delDeptMore, deptDetail} from '../../api/system'
export default {
  name: 'Department',
  components: { DropDown, TreeSingle },
  data () {
    return {
      item: {
        simplename: '',
        num: '',
        fullname: '',
        tips: '',
        pid: '',
        id: ''
      },
      search: {
        pId: '',
        value: ''
      },
      title: '',
      title_: '',
      dType: '',
      showAdd: false,
      show: false,
      all: false,
      id: '',
      type: 0,
      idList: [],
      hide: false,
      loading: true,
      value: '',
      editCheckId: 0,
      editCheckId_: 0,
      departmentData: [],
      departmentData_: [
        {
          id: -1,
          name: '无'
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      tableData: [],
      total: '',
      page: 1,
      rows: 10
    }
  },
  created () {
    this.getData(false)
  },
  methods: {
    getData: function (update) {
      deptTree().then(res => {
        this.departmentData = [
          res.data
        ]
        this.departmentData_ = [
          {
            id: -1,
            name: '无'
          },
          res.data
        ]
        console.log(this.departmentData)
        this.$refs.tree.setCheckedKeys([this.editCheckId])
        if (!update) {
          this.title = this.departmentData[0].name
        }
        this.handleSearch()
      }).catch(err => {
        console.log(err)
      })
    },
    checkChange: function (item, node, self) {
      this.page = 1
      this.loading = true
      this.id = ''
      this.idList = []
      if (item.id === this.editCheckId) {
        this.loading = false
        this.$refs.tree.setCheckedKeys([this.editCheckId])
      } else {
        this.editCheckId = item.id
        this.editCheckId_ = item.id
        this.title = item.name
        this.title_ = item.name
        this.$refs.tree.setCheckedKeys([item.id])
      }
      console.log(item)
      this.handleSearch()
    },
    selectAll: function () {
      this.type = 1
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1
          idList.push(data.id)
        })
        this.idList = idList
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0
          this.idList = []
        })
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data.id)
          } else {
            let idList = []
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.tableData.length
    },
    deleteSingle: function (id) {
      this.show = true
      this.id = id
      this.type = 0
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      }
      console.log(this.idList)
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      if (this.type === 0) {
        let body = {
          deptId: this.id
        }
        console.log(body)
        delDept(body).then(res => {
          console.log(res)
          this.getData(true)
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
          this.show = false
          this.id = ''
        }).catch(err => {
          console.log(err)
        })
      } else {
        let body = {
          deptIdLs: this.idList.join()
        }
        console.log(body)
        delDeptMore(body).then(res => {
          console.log(res)
          this.getData(true)
          this.all = false
          this.idList = []
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
          this.show = false
        }).catch(err => {
          console.log(err)
        })
      }
    },
    showAddModal: function (dType, data) {
      // 1--添加部门 2--修改左边部门 3--修改表格部门
      this.dType = dType
      if (this.dType === 1) {
        console.log('11111')
        this.editCheckId_ = this.editCheckId
        this.title_ = this.title
        this.item = {
          simplename: '',
          num: '',
          fullname: '',
          tips: '',
          pid: this.editCheckId
        }
        this.showAdd = true
      } else if (this.dType === 2) {
        console.log('22222')
        let body = {
          deptId: this.editCheckId
        }
        deptDetail(body).then(res => {
          console.log(res)
          this.item = res.data
          this.editCheckId_ = res.data.pid
          let body_ = {
            deptId: res.data.pid
          }
          if (res.data.pid !== 0) {
            deptDetail(body_).then(res_ => {
              console.log(res_)
              this.title_ = res_.data.simplename
              this.showAdd = true
            }).catch(err => {
              console.log(err)
            })
          } else {
            this.title_ = this.departmentData[0].name
            this.showAdd = true
          }
        }).catch(err => {
          console.log(err)
        })
      } else if (this.dType === 3) {
        console.log('33333')
        this.item = {
          simplename: data.simplename,
          num: data.num,
          fullname: data.fullname,
          tips: data.tips,
          pid: data.pid,
          id: data.id
        }
        this.editCheckId_ = data.pId
        this.title_ = this.title
        console.log(data)
        this.showAdd = true
      }
    },
    cancelAdd: function () {
      this.showAdd = false
    },
    confirmAdd: function () {
      console.log(this.item)
      if (this.dType === 1) {
        let body = {
          simplename: this.item.simplename,
          num: this.item.num,
          fullname: this.item.fullname,
          tips: this.item.tips,
          pid: this.item.pid === -1 ? '' : this.item.pid
        }
        console.log(body)
        deptAdd(body).then(res => {
          console.log(res)
          this.getData(true)
          this.$message({
            message: '添加成功!',
            type: 'success',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
          this.showAdd = false
        }).catch(err => {
          console.log(err)
        })
      } else {
        let body = {
          simplename: this.item.simplename,
          num: this.item.num,
          fullname: this.item.fullname,
          tips: this.item.tips,
          id: this.item.id,
          pid: this.item.pid
        }
        console.log(body)
        deptUpdate(body).then(res => {
          console.log(res)
          this.getData(true)
          this.$message({
            message: '修改成功!',
            type: 'success',
            center: 'true',
            duration: '1000',
            customClass: 'user-message'
          })
          this.showAdd = false
        }).catch(err => {
          console.log(err)
        })
      }
    },
    showDropInfo: function (data) {
      console.log(data)
      this.title_ = data.name
      this.editCheckId_ = data.id
      this.item.pid = data.id
    },
    handleSearch: function (click) {
      if (click) {
        this.page = 1
      }
      console.log(this.search)
      this.loading = true
      this.search.pId = this.editCheckId
      let body = {
        keywork: this.search.value,
        pid: this.editCheckId,
        page: this.page,
        rows: this.rows
      }
      console.log(body)
      deptList(body).then(res => {
        console.log(res)
        res.data.rows.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.rows
        this.total = res.data.total
        this.loading = false
        this.all = false
        this.idList = []
      }).catch(err => {
        console.log(err)
      })
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / 10) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / 10) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      } else {
        if (Math.round(this.total % 10) === 0) {
          this.page = parseInt(this.total / 10)
        } else {
          this.page = parseInt(this.total / 10) + 1
        }
        this.handleSearch()
      }
    }
  }
}
</script>

<style scoped>
  @import "System.css";
</style>



// WEBPACK FOOTER //
// src/page/system/Department.vue